import React from 'react';

import { ScreenLink, useScreenState } from '@gogame/screens';

import { groupsPreviewLink } from 'scenes/Gallery/ConversionPages/navigation';

const ConversionGroupPreviewScreenLink = ({ children, id }) => {
  const { filters } = useScreenState();

  return (
    <ScreenLink
      link={groupsPreviewLink}
      pathParams={{ groupId: `${id}` }}
      searchParams={{
        filters,
        creatives: {
          tableSettings: {
            orderDir: 'asc',
          },
        },
      }}
      underline={'always'}
      style={{
        minWidth: 0,
      }}
    >
      {children}
    </ScreenLink>
  );
};

export default ConversionGroupPreviewScreenLink;
